import { gaPushEvent } from "../base.analytics";

enum Event {
  PIN_ROOM = "pin_room",
  UNPIN_ROOM = "unpin_room",
  ROOM_RECOMMENDATION_SHOWN = "room_recommendation_shown",
}

/**
 * A recommended-room card reached the screen.
 *
 * This is the DENOMINATOR the PRD's primary metric compares against. Without
 * it, `room_joined` by channel gives joins per channel — a volume — but not a
 * card-to-join RATE, so "does the GPT card convert better than the feed card"
 * could not be answered at all: the GPT side had its impressions
 * (`juiscigpt_room_suggestion_shown`) and the feed side had none.
 *
 * Pairs with `room_joined` stamped `room_discovery_channel = "feed card"`,
 * which the card's navigation now carries — before it, a join from here was
 * indistinguishable from any other "public app" join, so the numerator was
 * wrong too.
 *
 * `surface` separates the two places the same recommendation is rendered: the
 * feed's single promo card, and the Rooms center's personalized section. They
 * convert differently and a merged rate would describe neither.
 */
export function gaEventRoomRecommendationShown(payload: {
  roomId: string;
  roomName: string;
  surface: "feed" | "rooms-center";
}) {
  gaPushEvent(Event.ROOM_RECOMMENDATION_SHOWN, {
    room_id: payload.roomId,
    room_name: payload.roomName,
    surface: payload.surface,
  });
}

export function gaEventPinRoom(payload: { roomId: string; roomName: string }) {
  gaPushEvent(Event.PIN_ROOM, {
    room_id: payload.roomId,
    room_name: payload.roomName,
  });
}

export function gaEventUnpinRoom(payload: {
  roomId: string;
  roomName: string;
}) {
  gaPushEvent(Event.UNPIN_ROOM, {
    room_id: payload.roomId,
    room_name: payload.roomName,
  });
}
